export function throwError(error: Error): never {
  throw error;
}
